module.exports = __webpack_public_path__ + "img/zip_icon.6cbba654.png";